import { PaginationType } from 'common';
import { PropertyType, UploadCsvType } from 'state';
import { AppRootStateType } from 'state/reducers';

export const selectProperties = (state: AppRootStateType): PropertyType[] =>
  state.properties.properties;
export const selectPropertiesSearch = (state: AppRootStateType): string | undefined =>
  state.properties.search;
export const selectPropertiesPagination = (state: AppRootStateType): PaginationType => ({
  page: state.properties.page,
  count: state.properties.count ?? 0,
});
export const selectCertainProperty = (state: AppRootStateType): PropertyType =>
  state.properties.certainProperty;
export const selectUploadedCsv = (state: AppRootStateType): UploadCsvType[] =>
  state.properties.uploadedCsv;

export const selectPropertiesIsLoading = (state: AppRootStateType): boolean =>
  state.properties.isLoading;
